import { Door } from './door';

export class DoorStatus extends Door {

    ts?: Date;
    is_opened?: boolean
    is_closed?: boolean

    constructor(door: Door) {
        super();
        Object.assign(this, door);
    }
}


// WEBPACK FOOTER //
// ./src/app/model/doorStatus.ts